/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 * Select component.
 */
import React, { Component } from 'react';
import { SelectField, MenuItem } from 'material-ui';
import { findSelectedIndex } from '../../common/helpers';

class Select extends Component {
    render() {
        const { value, options, label, notify } = this.props;
        return (
            <SelectField
                floatingLabelText={label}
                floatingLabelFixed
                fullWidth
                autoWidth={true}
                value={findSelectedIndex(options, value)}
                onChange={(event, index) => {
                    notify(options[index].id);
                }}
            >
                {
                    options.map((option, index) => {
                        return (
                            <MenuItem
                                key={index}
                                primaryText={option.name}
                                value={index}
                            />
                        );
                    })
                }
            </SelectField>
        );
    }
}

export default Select;



// WEBPACK FOOTER //
// ./components/data-containers/select.js